<template>
    <div class="home">
       <AppSideNav
			class="home__nav"
			:links="links"
			v-if="!$route.meta.origin"
		/>

		<div class="home__main">
			<AppHeader class="home__header"/>

			<div class="home__views">
				<router-view class="view"></router-view>
			</div>
		</div>
		<AppNotificationBanner :visible="bannerStatus" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	async mounted () {
		await this.$nextTick()
		this.$emit('mounted')
	},

	computed: {
		...mapGetters({
			bannerStatus: 'getBannerStatus'
		})
	},

	data () {
		return {
			links: [
				{ name: 'dashboard', text: 'Dashboard', icon: 'dashboard' },
				{ name: 'users', text: 'Users', icon: 'user' },
				{ name: 'messages', text: 'Messages', icon: 'message' },
				{ name: 'stickers', text: 'Stickers', icon: 'sticker' },
				{ name: 'orders', text: 'Orders', icon: 'order' },
				{ name: 'notification-post', text: 'Notification', icon: 'notification' }
				// { to: '/newsfeed-post',
				// 	text: 'Newsfeed',
				// 	icon: require('@/assets/icons/ic_error.png'),
				// 	children: [
				// 		{ to: '/newsfeed-post/main', text: 'Main', icon: require('@/assets/icons/ic_error.png') },
				// 		{ to: '/newsfeed-post/mid', text: 'Mid', icon: require('@/assets/icons/ic_error.png') },
				// 		{ to: '/newsfeed-post/subtags', text: 'Subtags', icon: require('@/assets/icons/ic_error.png') },
				// 		{ to: '/newsfeed-post/add-subtags', text: 'Add subtags', icon: require('@/assets/icons/ic_error.png') },
				// 		{ to: '/newsfeed-post/drafts', text: 'Drafts ', icon: require('@/assets/icons/ic_error.png') },
				// 		{ to: '/newsfeed-post/archives', text: 'Archives', icon: require('@/assets/icons/ic_error.png') }
				// 	]
				// }
			]
		}
	}
}
</script>

<style lang="scss" scoped>
.home {
    color: $default;
	height: 100vh;
	width: 100vw;
	overflow: hidden;
    display: flex;

	&__main {
		flex: 1 1 auto;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	&__nav {
		flex-shrink: 0;
	}

	&__views {
		flex: 1 1 auto;
		overflow: auto;
		background-color: #F5F6F8;

		.view {
			height: 100%;
			width: 100%;
			min-width: 850px;
		}
	}
}
</style>
